import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { type UserGroupSpecsFragment } from '../../../api/fragments/UserGroupSpecs';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import NoItemResult from '../../../components/results/NoItemResult';
import hasPermissions from '../../../utilities/hasPermissions';
import { useAddUserDrawer } from './UserGroupAddUserDrawer';

export type UserGroupUserEmptyListProps = { userGroup: UserGroupSpecsFragment };

const UserGroupUserEmptyList = ({ userGroup }: UserGroupUserEmptyListProps) => {
    const { t } = useTranslation(['userGroupDetails']);
    const addUserDrawer = useAddUserDrawer(userGroup);
    const { permissions: accountPermissions } = useAccount();
    const company = useCompany(true);
    const hasPermission = company
        ? hasPermissions(company.permissions, [permissionKind.createUserGroup]) &&
          hasPermissions(accountPermissions, [permissionKind.createUserGroup])
        : hasPermissions(accountPermissions, [permissionKind.createUserGroup]);

    return (
        <NoItemResult
            extra={
                <>
                    {hasPermission && (
                        <Button onClick={addUserDrawer.open} type="primary">
                            {t('userGroupDetails:tabs.users.noData.action')}
                        </Button>
                    )}
                    {addUserDrawer.render()}
                </>
            }
            subTitle={t('userGroupDetails:tabs.users.noData.message')}
        />
    );
};

export default UserGroupUserEmptyList;
